var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('list-page-shell',{attrs:{"title":"疑难单"}},[_c('order-workbench',{attrs:{"extra-query-params":{ status_color: 'red' },"show-create-button":false,"show-title":false}})],1)}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6920827c","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/views/DifficultList.vue
// module id = aY7+
// module chunks = 0